module.exports = __webpack_public_path__ + "img/34.d28c1a01.jpg";